import React from 'react';
import { Cpu, Github, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gate-dark border-t border-gate-border pt-16 pb-8" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-12" data-id="element-78">
          <div className="col-span-2 lg:col-span-2" data-id="element-79">
            <div className="flex items-center gap-2 mb-4" data-id="element-80">
              <div className="w-8 h-8 rounded-lg bg-gate-teal/10 flex items-center justify-center border border-gate-teal/20" data-id="element-81">
                <Cpu className="w-5 h-5 text-gate-teal" data-id="element-82" />
              </div>
              <span className="text-lg font-bold text-white" data-id="element-83">
                Open<span className="text-gate-teal" data-id="element-84">FPGA</span>
              </span>
            </div>
            <p className="text-gate-text-secondary text-sm max-w-xs mb-6" data-id="element-85">
              The unified interface for FPGA inference. Access high-performance,
              low-latency hardware without the complexity.
            </p>
            <div className="flex gap-4" data-id="element-86">
              <a href="#" className="text-gate-text-muted hover:text-white transition-colors" data-id="element-87">
                <Github className="w-5 h-5" data-id="element-88" />
              </a>
              <a href="#" className="text-gate-text-muted hover:text-white transition-colors" data-id="element-89">
                <Twitter className="w-5 h-5" data-id="element-90" />
              </a>
              <a href="#" className="text-gate-text-muted hover:text-white transition-colors" data-id="element-91">
                <Linkedin className="w-5 h-5" data-id="element-92" />
              </a>
            </div>
          </div>

          <div data-id="element-93">
            <h3 className="text-white font-semibold mb-4" data-id="element-94">Product</h3>
            <ul className="space-y-3 text-sm text-gate-text-secondary" data-id="element-95">
              <li data-id="element-96">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-97">
                  Accelerators
                </a>
              </li>
              <li data-id="element-98">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-99">
                  Playground
                </a>
              </li>
              <li data-id="element-100">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-101">
                  Rankings
                </a>
              </li>
              <li data-id="element-102">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-103">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-104">
            <h3 className="text-white font-semibold mb-4" data-id="element-105">Developers</h3>
            <ul className="space-y-3 text-sm text-gate-text-secondary" data-id="element-106">
              <li data-id="element-107">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-108">
                  Documentation
                </a>
              </li>
              <li data-id="element-109">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-110">
                  API Reference
                </a>
              </li>
              <li data-id="element-111">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-112">
                  SDKs
                </a>
              </li>
              <li data-id="element-113">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-114">
                  System Status
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-115">
            <h3 className="text-white font-semibold mb-4" data-id="element-116">Company</h3>
            <ul className="space-y-3 text-sm text-gate-text-secondary" data-id="element-117">
              <li data-id="element-118">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-119">
                  About
                </a>
              </li>
              <li data-id="element-120">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-121">
                  Blog
                </a>
              </li>
              <li data-id="element-122">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-123">
                  Careers
                </a>
              </li>
              <li data-id="element-124">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-125">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gate-border flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-126">
          <p className="text-sm text-gate-text-muted" data-id="element-127">
            © 2026 OpenFPGA. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gate-text-muted" data-id="element-128">
            <a href="#" className="hover:text-white transition-colors" data-id="element-129">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-130">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-131">
              Security
            </a>
          </div>
        </div>
      </div>
    </footer>;
}